module.exports = __webpack_public_path__ + "static/media/vaccineCerti.758d3900.svg";